const initialState = {
  Userinfo: null,
};

const UserInfoReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_USER_INFO':
      return {
        ...state,
        Userinfo: action.payload,
      };
    default:
      return state;
  }
};

export default UserInfoReducer;